import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import Layout from '../../components/Layout';
import Users from './sections/Users';

import { useAuth } from '../../contexts/AuthContext';
import { getAllUsers } from '../../actions/user';

const Dashboard = () => {
  const dispatch = useDispatch();

  const { currentUser } = useAuth();

  const users = useSelector((state) => state.user.users);

  console.log(currentUser, users);

  useEffect(() => {
    if (currentUser) {
      dispatch(getAllUsers());
    }
  }, [currentUser, dispatch]);

  if (!currentUser) {
    return <Redirect to="/" />;
  }

  return (
    <Layout>
      <div className="admin-dashboard">
        <div className="admin-inner">
          <Row>
            <Col sm={12} lg={10} xl={8}>
              <Users users={users} />
            </Col>
          </Row>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
